var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"popoutCard",class:{
      hide:
        !_vm.selected &&
        (!_vm.infoBlurb.value || !_vm.infoBlurb.routeNames.includes(_vm.$route.name)),
      inactive:
        !_vm.selected ||
        !_vm.infoBlurb.value ||
        !_vm.infoBlurb.routeNames.includes(_vm.$route.name),
    },style:(`background: ${_vm.selected ? _vm.colors[_vm.selected] : _vm.colors['help']}`)},[_c('div',{staticClass:"popoutColumnSelector"},[(false)?_c('div',{staticClass:"selectorCard cursor-pointer q-mb-xs",style:(`background: ${_vm.colors['help']}`),on:{"click":function($event){_vm.selected = _vm.selected == 'help' ? null : 'help'}}},[_c('q-icon',{staticClass:"text-white",staticStyle:{"margin":"auto"},attrs:{"name":"mdi-help-circle","size":"sm"}})],1):_vm._e(),(_vm.infoBlurb.value && _vm.infoBlurb.routeNames.includes(_vm.$route.name))?_c('div',{staticClass:"selectorCard cursor-pointer q-mb-xs",style:(`background: ${_vm.colors['info']}`),on:{"click":function($event){_vm.selected = _vm.selected == 'info' ? null : 'info'}}},[_c('q-icon',{staticClass:"text-primary",staticStyle:{"margin":"auto"},attrs:{"name":"mdi-information","size":"sm"}})],1):_vm._e()]),(
        _vm.selected == 'info' &&
        _vm.infoBlurb.value &&
        _vm.infoBlurb.routeNames.includes(_vm.$route.name)
      )?_c('div',{staticClass:"text-white"},[_c('q-scroll-area',{staticStyle:{"height":"380px"},attrs:{"thumb-style":{
          background: '#162c479c',
          opacity: 1,
          width: '8px',
          height: '8px',
          borderRadius: '20px',
        }}},[_c('div',{staticClass:"q-pa-md",staticStyle:{"color":"white"},domProps:{"innerHTML":_vm._s(_vm.infoBlurb.value)}})])],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }